import React, { useEffect, useRef } from 'react';
// AntV G2Plot
import { Pie } from '@antv/g2plot';
// i18
import { useTranslation } from 'react-i18next'

export const Dona = ({graph}) => {
    const donutChartRef = useRef(null);
    const { t } = useTranslation(["translation"])

    useEffect(() => {
        const data = []

        if (graph===null) {
            data.push(
                {
                    name: `${t("example")} 1`,
                    value: 45,
                },
                {
                    name: `${t("example")} 2`,
                    value: 20,
                },
                {
                    name: `${t("example")} 3`,
                    value: 80,
                },
                {
                    name: `${t("example")} 4`,
                    value: 90,
                },
                {
                    name: `${t("example")} 5`,
                    value: 75,
                },
            )
        }
        else if(graph.channel) {
            const campos = graph.fields[graph.channel]
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        } 
        else {
            const campos = graph.fields
            campos.forEach(element => {
                const obj = {
                    name: element.name,
                    value: element.value
                }
                data.push(obj)
            });
        }

        const donutPlot = new Pie(donutChartRef.current, {
            data,
            angleField: 'value',
            colorField: 'name',
            radius: 1,
            innerRadius: 0.6,
            legend: {
                position: 'right-top',
                itemSpacing: data.length + 1,
                itemName: {
                    style: {
                        fontSize: 15,
                    },
                },
            },
            label: {
                type: 'inner',
                offset: '-30%',
                style: {
                    fontSize: 18,
                    fontWeight: 'bold',
                },
                formatter: (datum) => `${datum.value}`,
            },
            interactions: [
                {
                    type: 'legend-filter',
                    enable: false,
                },
            ],
        });

        donutPlot.render();

        return () => {
            donutPlot.destroy();
        };
    }, []);

    return <div ref={donutChartRef} style={{ width: '80%', height: '80%' }} />;
};